export const PRODUCT_NAME = 'cruises'
export const CRUISE = 'CRUISE'
